import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    body {
        color: ${props => props.theme.functionColor?.function100};
        background-color: ${props => props.theme.functionColor?.function0};
    }
`;
